import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDetailsPageStore = defineStore('DetailsPage', () => {
  const isDetailsPageShown = ref(null)
  const slide = ref({})
  const chat = ref({})
  const page = ref('')

  function setSlideContent(value) {
    slide.value = value
  }

  function setPageChat(value) {
    chat.value = value
  }

  function setDetailsPageShown(value) {
    isDetailsPageShown.value = value
  }

  function closeDetailsPageShown() {
    isDetailsPageShown.value = null
  }

  function setPage(value) {
    page.value = value
  }

  return {
    isDetailsPageShown,
    slide,
    chat,
    page,

    setSlideContent,
    setPageChat,
    setDetailsPageShown,
    closeDetailsPageShown,
    setPage
  }
})
